import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations(['setAppLoader']),

    showAppLoader(text) {
      this.setAppLoader({ visible: true, text });
    },

    hideAppLoader() {
      this.setAppLoader({ visible: false });
    },
  },
};
